import { render, staticRenderFns } from "./StepThreeReview.vue?vue&type=template&id=2b1ef745&scoped=true"
import script from "./StepThreeReview.vue?vue&type=script&lang=js"
export * from "./StepThreeReview.vue?vue&type=script&lang=js"
import style0 from "./StepThreeReview.vue?vue&type=style&index=0&id=2b1ef745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1ef745",
  null
  
)

export default component.exports